module.exports = __webpack_public_path__ + "img/hoslogo12.906fd9ae.png";